"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gauge = void 0;
var Collector_1 = require("./Collector");
var utils_1 = require("./utils");
var Gauge = (function (_super) {
    __extends(Gauge, _super);
    function Gauge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'gauge';
        _this.gaugeValueMap = {};
        return _this;
    }
    Gauge.prototype.set = function (v, labelMap) {
        if (!Number.isFinite(v)) {
            throw new Error("Invalid Counter value: ".concat(v));
        }
        var key = labelMap ? (0, utils_1.hashLabelMap)(labelMap) : '';
        var gaugeValue = this.gaugeValueMap[key];
        if (!gaugeValue) {
            gaugeValue = { value: v, labelMap: labelMap };
            this.gaugeValueMap[key] = gaugeValue;
        }
        else {
            gaugeValue.value = v;
        }
    };
    Gauge.prototype.inc = function (v, labelMap) {
        if (v === void 0) { v = 1; }
        if (!Number.isFinite(v)) {
            throw new Error("Invalid Counter value: ".concat(v));
        }
        var key = labelMap ? (0, utils_1.hashLabelMap)(labelMap) : '';
        var gaugeValue = this.gaugeValueMap[key];
        if (!gaugeValue) {
            gaugeValue = { value: v, labelMap: labelMap };
            this.gaugeValueMap[key] = gaugeValue;
        }
        else {
            gaugeValue.value += v;
        }
    };
    Gauge.prototype.dec = function (v, labelMap) {
        if (v === void 0) { v = 1; }
        if (!Number.isFinite(v)) {
            throw new Error("Invalid Counter value: ".concat(v));
        }
        var key = labelMap ? (0, utils_1.hashLabelMap)(labelMap) : '';
        var gaugeValue = this.gaugeValueMap[key];
        if (!gaugeValue) {
            gaugeValue = { value: -v, labelMap: labelMap };
            this.gaugeValueMap[key] = gaugeValue;
        }
        else {
            gaugeValue.value -= v;
        }
    };
    Gauge.prototype.setToCurrentTime = function (labelMap) {
        this.set(Date.now() / 1000, labelMap);
    };
    Gauge.prototype.reset = function () {
        this.gaugeValueMap = {};
    };
    Gauge.prototype.collect = function () {
        var _a;
        var samples = [];
        var counterValues = Object.values(this.gaugeValueMap);
        for (var _i = 0, counterValues_1 = counterValues; _i < counterValues_1.length; _i++) {
            var counterValue = counterValues_1[_i];
            samples.push({
                value: counterValue.value,
                labels: (_a = counterValue.labelMap) !== null && _a !== void 0 ? _a : {},
                name: this.name,
            });
        }
        return samples;
    };
    return Gauge;
}(Collector_1.Collector));
exports.Gauge = Gauge;
//# sourceMappingURL=Gauge.js.map